import { render } from "./ResponseBox.vue?vue&type=template&id=9b4849bc"
import script from "./ResponseBox.vue?vue&type=script&lang=js"
export * from "./ResponseBox.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/Vakifbank-Vue-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__